// extracted by mini-css-extract-plugin
export default {"title":"Bc7eGwV w3QwoQC"};